import { RouteConfig } from 'vue-router';

import { multiGuard } from '../Middleware/MultiGuard';
import { permissionCalendar } from '../Middleware/permission/Calendar';

import { onboardingCalendar } from '../Middleware/onboarding/index';

export const NAME_ROUTES_CALENDAR = {
  CALENDAR: 'calendario'
};

export const Calendar: Array<RouteConfig> = [
  {
    path: '/calendario',
    component: () => import('@/layouts/Default/index.vue'),
    children: [
      {
        path: '',
        name: NAME_ROUTES_CALENDAR.CALENDAR,
        component: () => import(
          /* webpackChunkName: "calendar" */ '@/pages/Calendar/index.vue'
        ),
        meta: { title: 'Calendário' },
        beforeEnter: multiGuard([
          permissionCalendar,
          onboardingCalendar
        ])
      }
    ]
  }
];
